import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";
import { LONG_WRITE_TIMEOUT_MS } from "@/utils/axios-client";
import { LightOrderSheetSet } from "@/features/order-sheets/order-sheet.type";

export interface SubmitOrderSheetSetRequest {
  orderSheetIds?: number[];
}

export interface SubmitOrderSheetSetResponse {
  orderSheetSet: LightOrderSheetSet;
}

export interface SubmitOrderSheetSetsPathParameter {
  buyerId: number;
  orderSheetSetId: number;
}

export const submitOrderSheetSetKey: YWRKey<SubmitOrderSheetSetsPathParameter> =
  {
    url: (parameter) => {
      const { buyerId, orderSheetSetId } = parameter;
      return `/buyers/${buyerId}/order-sheet-sets/${orderSheetSetId}/submit`;
    },
    method: "post",
  };

export default function useSubmitOrderSheetSet() {
  const fetcher = useFetcher<
    SubmitOrderSheetSetRequest,
    SubmitOrderSheetSetResponse
  >();

  // 제출은 서버가 전 탭을 검증·확정하느라 30초를 넘길 수 있다 — 기본 타임아웃(30초)에 잘리지 않게.
  return useYWR(submitOrderSheetSetKey, fetcher, {
    timeout: LONG_WRITE_TIMEOUT_MS,
  });
}
